import { Styles } from 'react-select'
import styles from './MultiSelect.module.scss'
import { MultiSelectOption } from './MultiSelect.types'

export const customStyles: Partial<Styles> = {
  container: (base) => ({
    ...base,
    width: '100%'
    // border: `1px solid ${styles.borderMain}`
  }),
  control: (base, state) => {
    const {
      isFocused
    } = state
    return {
      ...base,
      border: `1px solid ${isFocused
        ? styles.primary
        : styles.borderMain}`,
      boxShadow: 'none',
      transition: 'all .3s',
      '&:hover': {
        border: `1px solid ${styles.primary}`,
        transition: 'all .3s'
      }
    }
  },
  valueContainer: (base, state) => {
    const options = state.options as MultiSelectOption[]
    const hasChangesToDisplay = options.some(o => Boolean(o.versionChange))
    return ({
      ...base,
      overflow: hasChangesToDisplay ? 'unset' : undefined
    })
  },
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none'
  }),
  placeholder: (base) => ({
    ...base,
    color: styles.placeholderContent,
    fontFamily: 'Open Sans',
    fontSize: 14,
    fontWeight: 'normal',
    whiteSpace:'nowrap'
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: styles.backgroundSecondary,
    borderRadius: 2,
    padding: '0 5px',
    margin: '3px 2px'
  }),
  multiValueLabel: (base) => ({
    ...base,
    padding: 0,
    paddingLeft: 0,
    margin: 0,
    fontSize: 10,
    lineHeight: '14px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: styles.white,
    textAlign: 'left',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  }),
  multiValueRemove: (base) => ({
    ...base,
    border: '1px solid red'
  }),
  option: (base) => ({
    ...base,
    textAlign: 'left'
  }),
  menuList: (base) => ({
    ...base,
    '::-webkit-scrollbar': {
      width: 3,
      height: 3,
      backgroundColor: 'transparent'
      // background-color: #f9f9f9;
    },

    '::-webkit-scrollbar-button': {
      display: 'none'
    },

    '::-webkit-scrollbar-thumb': {
      background: '#b9bbc9'
    },

    '::-webkit-scrollbar-track': {
      background: 'transparent',
      border: 0,
      borderRadius: 5
    }
  }),
  menu: base => ({
    ...base,
    marginTop: 0
  })
}
